import { t } from '@common/hooks/use-t.hook';
import { IIdObject } from '@common/interfaces/id-object.interface';
import { IItemPriceCommon } from '@common/utils/get-events/get-events.util';
import { IProductCatalogItemPrice } from '../pack-house-generated-api';

export interface ICachedItemPriceDto extends IItemPriceCommon, Omit<IProductCatalogItemPrice, 'id' | 'active'>, IIdObject {
    // item_price: {
    //     id: string;
    //     price: number;
    //     period_unit: 'week' | 'day' | 'month';
    //     shipping_period: number;
    //     shipping_period_unit: 'week' | 'day' | 'month';
    // } & Omit<IItemPrice, 'price' | 'period_unit' | 'shipping_period' | 'shipping_period_unit'>;
    id: string;
    clientDescription: string;
}

export const createCachedItemPriceDto = (price: IProductCatalogItemPrice): ICachedItemPriceDto => {
    return {
        // TODO remove
        ...price,
        id: price.id || '',
        clientDescription: getPriceClientDescription({ period: price.period, period_unit: price.period_unit }),
    };
};

export const getPriceClientDescription = (price: { period_unit?: string; period?: number; id?: string }): string => {
    if (price.period_unit === 'week') {
        if (price.period === 1) {
            return t('Weekly');
        } else if (price.period === 2) {
            return t('Fortnightly');
        } else if (price.period === 4) {
            return t('Monthly');
        }
    }
    return price.id || '';
};
